export default theme => ({
    
    div: {
        fontWeight: 500,
        color: theme.palette.text.secondary
    },

    // Reescribe propiedad para módulo control operativo
    header: {
        height: '45px',
    },
    popover:{
        minWidth: '350px',
        [theme.breakpoints.up('md')]: {
          width: '65%',
        },
    },
    popoverPorlet:{
        backgroundColor:"grey",
    },
    textColorPopover:{
        color:"white"
    },
    stopGreen:{
        color:"rgb(18, 188, 92)"
    },
    stopYellow:{
        color:"#dde00a"
    },
    updateTime:{
        fontWeight: 500,
        /* width: '200px' */
    },
    rounded: {
            color: '#3b3b3b',
            backgroundColor: '#fff',
            height: '30px'
    },
    buttonClosed:{
        textAlign:"right",
        color:'white'
    }
    
});
